import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbe00afe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "nav nav-tabs card-header-tabs" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = ["aria-selected"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-clipboard-check me-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-inline" }, "บันทึกผลการปฎิบัติราชการ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = ["aria-selected"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-invoice-dollar me-2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-inline" }, "บันทึกงบประมาณค่าใช้จ่าย", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["nav-link", {active: _ctx.activeTab === 'memo-list'}]),
            role: "tab",
            "aria-controls": "memo-list",
            "aria-selected": _ctx.activeTab === 'memo-list' ? 'true' : 'false',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActive('memo-list')))
          }, _hoisted_8, 10, _hoisted_5)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["nav-link", {active: _ctx.activeTab === 'budget-table'}]),
            role: "tab",
            "aria-controls": "budget-table",
            "aria-selected": _ctx.activeTab === 'budget-table' ? 'true' : 'false',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActive('budget-table')))
          }, _hoisted_13, 10, _hoisted_10)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activityComponent), {
        "activity-id": _ctx.activityId,
        "province-id": _ctx.provinceId
      }, null, 8, ["activity-id", "province-id"]))
    ])
  ]))
}